import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
const names = ['Martín G.', 'Sofía R.', 'Lucas M.', 'Camila T.', 'Agustín P.', 'Valentina L.', 'Joaquín S.', 'Martina C.', 'Matías B.', 'Lucía F.', 'Facundo D.', 'Florencia V.', 'Tomás A.', 'Julieta N.', 'Nicolás H.'];
const cities = ['Ciudad de México', 'Bogotá', 'Lima', 'Madrid', 'Santiago', 'Buenos Aires', 'Quito', 'Caracas', 'Guadalajara', 'Medellín', 'Monterrey', 'Cali', 'Guayaquil', 'Arequipa', 'Valencia'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    city: '',
    time: 1
  });
  useEffect(() => {
    const triggerPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 15) + 1;
      setCurrentBuyer({
        name: randomName,
        city: randomCity,
        time: randomTime
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 6000);
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(triggerPopup, 10000);
    // Then every 30 seconds
    const interval = setInterval(triggerPopup, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-161">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-24 md:bottom-6 left-4 md:left-6 z-50 bg-white rounded-lg shadow-xl p-4 pr-10 border border-gray-100 max-w-xs w-[calc(100%-2rem)] md:w-auto" data-id="element-162">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-163">
            <X size={16} data-id="element-164" />
          </button>
          <div className="flex items-center gap-3" data-id="element-165">
            <div className="w-10 h-10 rounded-full bg-brand-teal text-white flex items-center justify-center font-bold text-sm flex-shrink-0" data-id="element-166">
              {currentBuyer.name.charAt(0)}
            </div>
            <div data-id="element-167">
              <p className="text-sm text-gray-800 font-medium leading-tight" data-id="element-168">
                <span className="font-bold" data-id="element-169">{currentBuyer.name}</span> de{' '}
                {currentBuyer.city} acaba de comprar el MEGA PACK 🎉
              </p>
              <p className="text-xs text-gray-500 mt-1" data-id="element-170">
                Hace {currentBuyer.time}{' '}
                {currentBuyer.time === 1 ? 'minuto' : 'minutos'}
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}